import Bugsnag, { Client } from '@bugsnag/js';
import BugsnagPluginExpress from '@bugsnag/plugin-express';
import * as config from '../configuration';
var browserIgnoreErrors = [/^No error$/, /__show__deepen/, /Access is denied/, /anonymous function: captureException/, /Blocked a frame with origin/, /console is not defined/, /DataCloneError/, /event is not defined/, /feedConf/, /MyIPhoneApp/, /snapchat.com/, /vid_mate_check is not defined/, /win\.document\.body/, /window\._sharedData\.entry_data/, /ztePageScrollModule/,
// React specific
/Cannot read property 'className' of undefined/, /Permission denied to access property "apply"/, /Failed to register a ServiceWorker/];
var productionDisableCallback = function productionDisableCallback(callback: () => void) {
  if (config.app.APP_ENV !== 'production') {
    callback();
  }
};
var bugsnagLoggerPrefix = "[bugsnag:".concat(config.app.APP_ENV, "]: ");
var bugsnagLogger = {
  debug: function debug(e: any) {
    return productionDisableCallback(function () {
      return console.debug("".concat(bugsnagLoggerPrefix).concat(e));
    });
  },
  info: function info(e: any) {
    return productionDisableCallback(function () {
      return console.info("".concat(bugsnagLoggerPrefix).concat(e));
    });
  },
  warn: function warn(e: any) {
    return productionDisableCallback(function () {
      return console.warn("".concat(bugsnagLoggerPrefix).concat(e));
    });
  },
  error: function error(e: any) {
    return productionDisableCallback(function () {
      return console.error("".concat(bugsnagLoggerPrefix).concat(e));
    });
  }
};
var exported: Client | null = config.bugsnag.BUGSNAG_API_KEY ? Bugsnag.isStarted() ? Bugsnag : Bugsnag.start({
  apiKey: config.bugsnag.BUGSNAG_API_KEY,
  appType: (process as any).browser ? 'browser' : 'node',
  logger: bugsnagLogger,
  releaseStage: config.app.APP_ENV,
  plugins: [BugsnagPluginExpress],
  onError: function onError(event) {
    if (browserIgnoreErrors.some(function (ignoreError) {
      return ignoreError.test(event.errors[0].errorMessage);
    })) {
      return false;
    }
  }
}) : null;
export default exported;